export default class Tarefa {
  constructor() {
    this.id = ""
    this.nome = ""
    this.prazoLegal = ""
    this.prazoEntrega = ""
    this.aPartirDe = ""
    this.statusId = ""
    this.geraMulta = ""
    this.padrao = ""
    this.ativo = ""
    this.empresasIds = []
    this.responsavelId = ""
    this.departamentoId = ""
    this.departamentoPadraoId = ""
    this.recorrenciaId = ""
    this.competenciaId = ""
    this.tipoPrazoEntregaFinalId = ""
    this.tipoPrazoEntregaLegalId = ""
    this.tipoTarefaId = ""
    this.descricao = ""
    this.tarefaCliente = false
    this.inicioPrazoLegal = "0"
    this.inicioPrazoEntrega = "0"
    this.tipoDecendio = ""
    this.parcelada = false
    this.complementoTarefa = {}
    this.complementoTarefa.fases = null
    this.complementoTarefa.responsaveisTarefaCliente = null
    this.anexo = []
    this.categoriaId = ""
    this.categoriaPersonalizada = ""
    this.categoriaPersonalizadaId = ""
    this.ultimoDiaPrazoEntregaFinal = false
    this.ultimoDiaPrazoEntregaLegal = false
    this.desativarConclusaoManual = false
    this.ajustarVencimentoDiasNaoUteis = false
    this.tipoAjusteVencimentoId = null
    this.isSabadoDiaUtil = false
  }
}
